import React from 'react'
import reactStamp from 'react-stamp'

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';

import './home.css'

export default reactStamp(React).compose({

    init(){
        this.handleOpen = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this._handleSubmit = this._handleSubmit.bind(this);
        this.handleTextFieldChange = this.handleTextFieldChange.bind(this);
    },

    componentWillReceiveProps(nextProps) {
        this.setState({
            patientAddressLine: nextProps.patientAddressLine,
            patientAddressCity: nextProps.patientAddressCity,
            patientAddressState: nextProps.patientAddressState,
            patientAddressPostalCode: nextProps.patientAddressPostalCode,
            patientAddressCountry: nextProps.patientAddressCountry,
            patientPhone: nextProps.patientPhone,
            err: {}
        });
    },

    state: {
        open: false,
        err: {}
    },

    handleOpen(){
        this.setState({open: true, err: {}});
        this.state.patientAddressLine = this.props.patientAddressLine;
        this.state.patientAddressCity = this.props.patientAddressCity;
        this.state.patientAddressState = this.props.patientAddressState;
        this.state.patientAddressPostalCode = this.props.patientAddressPostalCode;
        this.state.patientAddressCountry = this.props.patientAddressCountry;
        this.state.patientPhone = this.props.patientPhone;
    },

    handleClose(){
        this.setState({open: false});
    },

    _handleSubmit(e){
        e.preventDefault();
        let err = false;

        Object.keys(this.state.err).forEach((key, index) => {
            if (this.state.err[key] != "") {
                err = true;
            }
        });

        if (!err) {
            this.setState({open: false});
            this.props.handleSubmit(
                this.state.patientAddressLine,
                this.state.patientAddressCity,
                this.state.patientAddressState,
                this.state.patientAddressPostalCode,
                this.state.patientAddressCountry,
                this.state.patientPhone
            )
        }
    },

    handleTextFieldChange(e, field) {
        var _field = {};
        _field[field.fieldName] = e.target.value;
        this.setState({..._field});

        let _state = this.state;
        if (e.target.value != "" && e.target.value !== undefined) {
            _state.err[field.fieldName] = ''
        } else {
            _state.err[field.fieldName] = 'Please, fill this field'
        }
        this.setState({_state})
    },

    render() {
        const actions = [
            <FlatButton
                label="Discard"
                primary={true}
                onTouchTap={this.handleClose}
            />,
            <FlatButton
                label="Submit"
                primary={true}
                disabled={false}
                onTouchTap={this._handleSubmit}
            />,
        ];

        const textFields = [];
        let index = 0;
        let {handleSubmit, ...fieldNames} = this.props;
        for (let fieldName in fieldNames) {

            let name = fieldName.match(/[A-Z][a-z]+/g).join(' ').replace('Address', '');

            textFields.push(
                <TextField
                    key={index}
                    className="textfield"
                    floatingLabelText={name}
                    floatingLabelFixed={true}
                    value={this.state[fieldName]}
                    onChange={(e)=>this.handleTextFieldChange(e, {fieldName})}
                    errorText={this.state.err[fieldName]}
                />
            )
            index++;
        }

        const customContentStyle = {
            minWidth: '300px',
            maxWidth: '600px',
        };

        return (
            <div>
                <RaisedButton className="editButton" primary={true} label="Edit" onTouchTap={this.handleOpen}/>
                <Dialog
                    title="Edit Address"
                    actions={actions}
                    modal={true}
                    open={this.state.open}
                    autoScrollBodyContent={true}
                    contentStyle={customContentStyle}
                >
                    <form>
                        {textFields}
                    </form>
                </Dialog>
            </div>
        );
    }

});






/** WEBPACK FOOTER **
 ** ./src/app/components/Home/EditInfoDialog.js
 **/